import { ItemStatus } from '@/ui/components/items-status'
import { CompensationLabel } from '@/ui/components/process-details/compensation-label'
import { Base } from '@itsrever/design-system'
import { clsx } from 'clsx'
import { ProductPreview } from '@/ui/components/process-details'
import { RefundMethod } from '@/domain/refund'
import { ReturnedItem } from '@/domain/returns'

const { Card } = Base

interface NotReturnedProductCardProps {
  lineItem: ReturnedItem
  userSelectedPm: RefundMethod
}

export const NotReturnedProductCard: React.FC<NotReturnedProductCardProps> = ({
  lineItem,
  userSelectedPm
}) => {
  return (
    <Card className="overflow-hidden">
      <div
        className={clsx(
          'flex h-12 w-full items-center justify-between p-2 px-4',
          'border-b border-solid border-[#E1E4EAFF] bg-[#F5F7FAFF]'
        )}
      >
        <CompensationLabel
          refundMethod={userSelectedPm}
          action={lineItem.action}
        />
        {lineItem.review ? <ItemStatus status={lineItem.review} /> : null}
      </div>
      <div className="p-3">
        <div className="flex">
          <ProductPreview lineItem={lineItem} restocked={false} />
        </div>
      </div>
    </Card>
  )
}
